module.exports = __webpack_public_path__ + "img/Minister.f7b2ea1f.jpg";